import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { RootState } from '@/index';
import { IssueStatus } from '@/utils/constant';
import { showMsg } from '@/utils/util';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Row, Col } from 'antd';
import './index.scss';
const fetchApi = new IssueApi();
interface Props {
  vehicleName: string;
  open: boolean;
  setOpen: AnyFunc;
}
const DiscardIssueModal = (props: Props) => {
  const { vehicleName, open, setOpen } = props;
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const currentIssue =
    issueList &&
    issueList.find((item: any) => item.vehicleName === vehicleName);
  const { issueNumber } = currentIssue || {};
  const confirmDiscard = async (
    issueNumber: string,
    acceptNewIssue: boolean,
  ) => {
    try {
      const res = await fetchApi.discardIssue({ issueNumber, acceptNewIssue });
      if (res.code === HttpStatusCode.Success) {
        showMsg({ msg: '抛单成功!', type: 'success' });
      } else {
        showMsg({ msg: res.message, type: 'error' });
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        centered
        destroyOnHidden
        footer={
          <>
            <div className='footer' style={{ justifyContent: 'flex-end' }}>
              <div className='operate'>
                <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  onClick={() => {
                    confirmDiscard(issueNumber, true);
                  }}
                >
                  确认抛单
                </Button>
                {issueList &&
                  issueList.length > 1 &&
                  issueList.find(
                    (item: any) => item.issueStatus === IssueStatus.ON_HOLD,
                  ) &&
                  currentIssue?.issueStatus != IssueStatus.ON_HOLD && (
                    <Button
                      style={{
                        marginLeft: '12px',
                      }}
                      type={'primary'}
                      onClick={() => {
                        confirmDiscard(issueNumber, false);
                      }}
                    >
                      确定抛单并受理挂起工单
                    </Button>
                  )}
              </div>
            </div>
          </>
        }
      >
        <>
          <div className='content-container' style={{ fontSize: '14px' }}>
            <Row justify={'start'} align={'middle'}>
              <Col>
                <img
                  src={require('@/assets/img/views/instruct/warning_icon.png')}
                  style={{ marginRight: '8px' }}
                ></img>
              </Col>
              <Col style={{ color: '#fff' }}>确认是否抛单？</Col>
            </Row>
            <Row>
              <Col
                style={{
                  color: '#868D9F',
                  paddingLeft: '48px',
                  marginBottom: '54px',
                }}
              >
                工单将抛至驾舱池，仅驾舱端座席能受理此单
              </Col>
            </Row>
          </div>
        </>
      </Modal>
    </>
  );
};
export default React.memo(DiscardIssueModal);
